export class ReasonModel{
    id?: number;
    operatingCountryId: number;
    operatingCountryCode: string;
    reasonNote: Date;
    rowStatusId: number;
    createdBy: number;
    updatedBy:number;   
    
}


// WEBPACK FOOTER //
// ./src/app/customerservice/interface/ticketingsystem/reasons.modal.ts